import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

/**
 * Decrements every second until midnight of the local day, then auto-resets
 * to the next day. Always returns hh:mm:ss left until 23:59:59 local time.
 */
const computeRemaining = () => {
  const now = new Date();
  const end = new Date(now);
  end.setHours(23, 59, 59, 999);
  let ms = end - now;
  if (ms < 0) ms = 0;
  const h = Math.floor(ms / 3_600_000);
  const m = Math.floor((ms % 3_600_000) / 60_000);
  const s = Math.floor((ms % 60_000) / 1000);
  return { h, m, s };
};

const pad = (n) => String(n).padStart(2, "0");

export default function DayCountdown({ testId }) {
  const [t, setT] = useState(computeRemaining);

  useEffect(() => {
    const id = setInterval(() => setT(computeRemaining()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      data-testid={testId}
      className="inline-flex items-center gap-4 px-5 py-3 rounded-2xl border border-[hsl(var(--gold))]/55 bg-gradient-to-br from-[hsl(var(--gold))]/[0.14] via-[hsl(var(--gold))]/[0.06] to-transparent backdrop-blur-sm shadow-[0_0_24px_-8px_hsl(var(--gold-deep)/0.55)]"
    >
      <div className="size-9 grid place-items-center rounded-xl bg-[hsl(var(--bg))]/70 border border-[hsl(var(--gold))]/40 text-gold-bright shrink-0">
        <Clock size={18} />
      </div>
      <div className="flex flex-col leading-tight">
        <span className="text-[10px] uppercase tracking-[0.28em] text-[hsl(var(--text-muted))]">
          Prix valable encore
        </span>
        <span className="font-display text-2xl md:text-[28px] text-gold-bright tabular-nums tracking-wider">
          {pad(t.h)}<span className="text-[hsl(var(--text-dim))]">:</span>
          {pad(t.m)}<span className="text-[hsl(var(--text-dim))]">:</span>
          {pad(t.s)}
        </span>
      </div>
    </div>
  );
}
